/**
 * InputLabel Component
 *
 * Abstraction layer over MUI InputLabel.
 * Used with OutlinedInput for custom form layouts.
 */

import { InputLabel as MuiInputLabel, InputLabelProps } from '@mui/material';
import React from 'react';

const InputLabel = React.forwardRef<HTMLLabelElement, InputLabelProps>((props, ref) => {
  return <MuiInputLabel ref={ref} {...props} />;
});

InputLabel.displayName = 'InputLabel';

export default InputLabel;
